<template>
    <div class="persistent-menu">
        <v-menu v-model="menu" :nudge-width="200" top offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="openMenu">
                    <v-icon :color="styles.primaryColor">menu</v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-list class="pa-0">
                    <v-list-item @click="back_to_main_menu">
                        <div style="height: 48px;"></div>
                        <v-list-item-title class="subtitle-2 font-weight-bold grey--text">
                            <v-icon v-if="inSubMenu">mdi-arrow-left-circle</v-icon>
                            {{ subMenuTitle }}
                        </v-list-item-title>

                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list class="pa-0" dense>
                    <v-list-item v-for="item in items" :key="item.id" @click="click_menu_item(item)">
                        <div style="height: 48px;"></div>
                        <v-list-item-title style="max-width: 100%;">{{ item.title }}</v-list-item-title>
                        <v-icon v-if="item.type==='submenu'">mdi-arrow-right-circle</v-icon>
                    </v-list-item>
                </v-list>

                <v-card-actions>
                    <span class="sp-ves">{{version_fpt_ai_lc}}</span>
                    <div class="flex-grow-1"></div>

                    <span v-if="styles.disabledPoweredByLink === true" class="fpt-powered caption font-italic">Powered by FPT.AI</span>
                    <a v-else class="fpt-bot-url" target="_blank" href="https://fpt.ai/chatbot" rel="nofollow">
                        <span class="caption font-italic">Powered by FPT.AI</span>
                    </a>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import handlerMessage from '../business/handler_messages'
import handlerData from '../business/handler_data'
import { mapState } from 'vuex'

export default {
    name    : 'persistent-menu',
    data() {
        return {
            persistent_menus : [],
            items            : [],
            menu             : false,
            inSubMenu        : false,
            subMenuTitle     : 'Menu',
            version_fpt_ai_lc: ''
        }
    },
    async mounted() {
        this.$nextTick(async () => {
            await this.load_persistent_menus()
            this.items             = this.persistent_menus
            this.version_fpt_ai_lc = process.env.VUE_APP_FPTAI_LIVECHAT_VERSION
        })

    },
    computed: {
        ...mapState(['styles'])
    },
    methods : {
        btn_msg_click(btn_detail) {
            // console.log(btn_detail);
            if (btn_detail.payload && btn_detail.payload !== '') {
                let send_msg_content = btn_detail.payload
                if (send_msg_content.indexOf('#') >= 0) {
                    send_msg_content += '#' + btn_detail.title
                } else {
                    send_msg_content += '##' + btn_detail.title
                }

                // console.log(send_msg_content)
                handlerMessage.send_message_to_socket('payload', send_msg_content, this.$store.state.subChannel)

            } else if (btn_detail.url && btn_detail.url !== '') {
                // handler url
                handlerData.clickOpenLink(btn_detail.url)

            } else if (btn_detail.phone_call && btn_detail.phone_call !== '') {

                // phone call
                handlerData.clickCallPhone(btn_detail.phone_call)

            }

        },

        click_menu_item(m) {
            // console.log(m)
            if (m.type === 'web_url') {
                // handler url
                handlerData.clickOpenLink(m.content)

            } else if (m.type === 'payload') {
                // TODO with url & phone number
                // send msg to socket
                let send_msg_content = m.content
                if (send_msg_content.indexOf('#') >= 0) {
                    send_msg_content += '#' + m.title
                } else {
                    send_msg_content += '##' + m.title
                }

                // console.log(send_msg_content)
                handlerMessage.send_message_to_socket('payload', send_msg_content, this.$store.state.subChannel)

                // hide menu
                this.menu = false
            } else if (m.type === 'submenu') {
                this.menu = false
                // this.$nextTick(() => {
                //   this.inSubMenu = true
                //   this.subMenuTitle = m.title
                //   this.items = m.content
                //   this.menu = true
                // })

                setTimeout(function () {
                    this.inSubMenu    = true
                    this.subMenuTitle = m.title
                    this.items        = m.content
                    this.menu         = true
                }.bind(this), 100)

            }
        },

        openMenu() {
            if (this.inSubMenu) {
                this.menu = false
                this.$nextTick(() => {
                    this.inSubMenu    = false
                    this.subMenuTitle = 'Menu'
                    this.items        = this.persistent_menus
                    this.menu         = true
                })
            }
        },

        back_to_main_menu() {
            // console.log('back_to_main_menu')
            if (this.inSubMenu) {
                this.menu = false
                // this.$nextTick(() => {
                //   this.inSubMenu = false
                //   this.subMenuTitle = 'Menu'
                //   this.items = this.persistent_menus
                //   this.menu = true
                // })
                setTimeout(function () {
                    this.inSubMenu    = false
                    this.subMenuTitle = 'Menu'
                    this.items        = this.persistent_menus
                    this.menu         = true
                }.bind(this), 100)
            }
        },

        async load_persistent_menus() {
            let dataPersistent = await handlerData.get_persistent_menus(this.$store.state.botCode)
            if (dataPersistent) {
                this.persistent_menus = dataPersistent
            }
        }

    }
}
</script>

<style scoped>
    .sp-ves {
        font-size   : 11px;
        font-style  : italic;
        margin-left : 6px;
    }
    .fpt-bot-url {
        font-size   : 12px;
        margin-right    : 10px;
        text-decoration : none;
    }
    .fpt-powered {
        font-size   : 12px;
        margin-right    : 10px;
    }
</style>
